"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigationModule = _interopRequireDefault(require("./navigation.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavHeader = function NavHeader(props) {
  var id = props.id,
      children = props.children,
      href = props.href,
      onBarsClick = props.onBarsClick,
      onClick = props.onClick;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: _navigationModule.default["navbar-header"]
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_button") : null,
    type: "button",
    className: _navigationModule.default["navbar-toggle"],
    "data-toggle": "collapse",
    "data-target": ".navbar-collapse",
    onClick: onBarsClick
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_icon_bar_1") : null,
    className: _navigationModule.default["icon-bar"]
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_icon_bar_2") : null,
    className: _navigationModule.default["icon-bar"]
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_icon_bar_3") : null,
    className: _navigationModule.default["icon-bar"]
  })), children && _react.default.createElement("a", {
    id: id ? "".concat(id, "_nav_bar_brand") : null,
    className: _navigationModule.default["navbar-brand"],
    href: href,
    onClick: onClick
  }, children));
};

NavHeader.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,
  children: _propTypes.default.any,

  /** string with the href */
  href: _propTypes.default.string,

  /** Callback called in mobile burger menu click */
  onBarsClick: _propTypes.default.func,

  /** Callback called when clicking the link */
  onClick: _propTypes.default.func
};
var _default = NavHeader;
exports.default = _default;